export default "__VITE_ASSET__CFBkvShs__"